import { AuthActions, AuthActionTypes, LoggedIn } from '@state/actions/auth/auth.actions';
import { Identity, Principal, Token } from '@state/reducers/auth/auth.models';

export interface IAuthState {
    principal: Principal;
    identity: Identity;
    pending: boolean;
    tokenRefreshPending: boolean;
}

export const initialState: IAuthState = {
    principal: new Principal(new Token(sessionStorage.getItem('auth_token'))),
    identity: null,
    pending: false,
    tokenRefreshPending: false
};

export function reducer(state = initialState, action: AuthActions): IAuthState {
    switch (action.type) {

        case AuthActionTypes.INIT_TOKEN: {
            const payload = (action as LoggedIn).payload;

            return {
                ...state,
                principal: new Principal(new Token(payload.token)),
                pending: false
            };
        }

        case AuthActionTypes.LOG_IN_PENDING:
            return {
                ...state,
                principal: new Principal(null),
                identity: null,
                pending: true
            };

        case AuthActionTypes.LOGGED_IN: {
            const payload = (action as LoggedIn).payload;
            return {
                ...state,
                principal: new Principal(new Token(payload.token)),
                pending: false
            };
        }

        case AuthActionTypes.LOG_OUT: {
            return {
                ...state,
                principal: new Principal(null),
                identity: null,
                pending: false
            };
        }

        default:
            return state;
    }
}
